import { shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { permissionGroup, permissionTypes } from '../../common/permissionGroup';

const PermissionsGate = ({ children, can, errorComponent }) => {
  const {
    getMyProfile: {
      permissions
    } = {}
  } = useSelector((state) => ({
    getMyProfile: state.getMyProfile,
  }), shallowEqual);

  const [canGroup, canPermission] = can.split(':');

  const isAdmin = permissions?.find(
    ({ group, permission }) => group === permissionGroup.ADMIN && permission === permissionTypes.ADMIN
  );

  const permissionGranted = isAdmin || permissions?.find(
    ({ group, permission }) => group === canGroup && permission === canPermission
  );

  return permissionGranted ? children : errorComponent;
};

PermissionsGate.propTypes = {
  children: PropTypes.node.isRequired,
  can: PropTypes.string.isRequired,
  errorComponent: PropTypes.node
};

PermissionsGate.defaultProps = {
  errorComponent: null
};

export default PermissionsGate;
